import {
  QualityRegimeOptions,
  correctionReasonOptions,
  deliveryContextGMNOptions,
  gmnEventOptions,
  groundwaterAspectOptions,
  monitoringPurposeOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchemaField, getEnumNamesAndDisabled } from "@/libs/brostar-form";

import { ExplainExcelMeasuringpoint } from "../components/explain-excel-add-measuring-point";

/**
 * UI Schema library for all GMN forms.
 * Returns a flat object with all field UI schema configurations.
 */
export const createGmnUiSchemaLibrary = (qualityRegime: QualityRegimeOptions | undefined) =>
  ({
    // Shared metadata fields
    projectNumber: {},
    broIdGMN: {
      "ui:widget": "GmnSelectDropdown",
    },
    broIdGMW: {
      "ui:widget": "GmwSelect",
    },
    qualityRegime: getEnumNamesAndDisabled(qualityRegimeOptions, qualityRegime),
    deliveryAccountableParty: {
      "ui:widget": "OrganisationSelect",
    },
    correctionReason: getEnumNamesAndDisabled(correctionReasonOptions, qualityRegime),

    // GMN Start Registration fields
    name: {},
    objectIdAccountableParty: {},
    deliveryContext: getEnumNamesAndDisabled(deliveryContextGMNOptions, qualityRegime),
    monitoringPurpose: getEnumNamesAndDisabled(monitoringPurposeOptions, qualityRegime),
    groundwaterAspect: getEnumNamesAndDisabled(groundwaterAspectOptions, qualityRegime),
    startDateMonitoring: {},
    // measuringPoints uses the SelectMeasuringPoints — options set dynamically per form
    measuringPoints: {
      "ui:field": "SelectMeasuringPoints",
    },

    // GMN Closure fields
    endDateMonitoring: {},

    // GMN Edit Measuring Point fields
    eventType: getEnumNamesAndDisabled(gmnEventOptions, qualityRegime),
    eventDate: {},
    measuringPointCode: {},
    tubeNumber: {},

    // File fields
    measuringPointsFile: {
      "ui:explanation": <ExplainExcelMeasuringpoint />,
      "ui:widget": "FileWidget",
      "ui:options": {
        accept:
          ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
  } satisfies Record<string, BrostarUiSchemaField>);
